import Vue from 'vue';
import VueTimepicker from 'vue2-timepicker';

import 'vue2-timepicker/dist/VueTimepicker.css';
Vue.use(VueTimepicker); // config is optional. more below
